/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceItem1
 */
export interface AdditionalServiceItem1 {
    /**
     * 附加服务ID
     * @type {number}
     * @memberof AdditionalServiceItem1
     */
    additionalServiceId: number;
    /**
     * 金额
     * @type {number}
     * @memberof AdditionalServiceItem1
     */
    amount: number;
    /**
     * 货币代码，默认 KRW
     * @type {string}
     * @memberof AdditionalServiceItem1
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the AdditionalServiceItem1 interface.
 */
export function instanceOfAdditionalServiceItem1(value: object): value is AdditionalServiceItem1 {
    if (!('additionalServiceId' in value) || value['additionalServiceId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function AdditionalServiceItem1FromJSON(json: any): AdditionalServiceItem1 {
    return AdditionalServiceItem1FromJSONTyped(json, false);
}

export function AdditionalServiceItem1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceItem1 {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'],
        'amount': json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function AdditionalServiceItem1ToJSON(json: any): AdditionalServiceItem1 {
    return AdditionalServiceItem1ToJSONTyped(json, false);
}

export function AdditionalServiceItem1ToJSONTyped(value?: AdditionalServiceItem1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
    };
}

